import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const CountryStateServiceInterfaceToken: InjectionToken<CountryStateServiceInterface> =
  new InjectionToken<CountryStateServiceInterface>('CountryStateServiceInterface');

export interface Country {
  code: string; // ISO 3166 alpha-2 code
  name: string;
}

export interface State {
  code: string;
  name: string;
}

export interface CountryStateServiceInterface {
  getCountriesOptions(): Observable<Country[]>;
  getStatesOptions(countryCode: string): Observable<State[]>;
}
